import CheckmateApiClient from '../../../services/apiClient';
import { IErrorContent } from '../../../interfaces/IError';
import { IQuadZoneNoteRequest } from '../../../interfaces/IQuad';
import { useMutation } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useCreateZoneNoteMutation = () => {
    return useMutation({
        mutationFn: async (quadZoneNoteRequest: IQuadZoneNoteRequest) => {
            const response = await _apiClient.createZoneNote(quadZoneNoteRequest);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: IErrorContent = {
                    message: response.errorMessage || 'Failed to create zone note',
                    errors: response.errors,
                };
                throw error;
            }

            return response.payload;
        },
    });
};
